<script>
  import { Modal, Select } from 'flowbite-svelte';
  import { LoadingButton } from '@button/ui';
  import COUNTRY_CODE_DATA from '../../lib/country_codes.json';
  import {
    MUTATION_KEY_PROFILE_UPDATE_COUNTRY,
    QUERY_KEY_USER_DATA,
    QUERY_KEY_USER_PROFILE,
  } from '../constants';
  import { updateUserProfile } from '../data/userData';
  import { useQueryClient, createMutation } from '@tanstack/svelte-query';
  import { queryUserData } from '@button/ui/data';
  import { createProfileModalOpen } from '../store';
  import { _ } from 'svelte-i18n';

  let loading = false;
  let country;

  const queryClient = useQueryClient();

  const userQuery = queryUserData();

  const mutation = createMutation({
    mutationKey: MUTATION_KEY_PROFILE_UPDATE_COUNTRY,
    mutationFn: updateUserProfile,
    onMutate: () => {
      loading = true;
    },
    onSettled: () => {
      loading = false;
      queryClient.invalidateQueries([
        QUERY_KEY_USER_DATA,
        QUERY_KEY_USER_PROFILE,
      ]);
    },
  });

  const submitForm = async (event) => {
    event.preventDefault();

    $mutation.mutate({
      country,
    });
  };

  /**
   * If the user is pretending to be another user we want to make sure
   * to not show this modal otherwise they get stuck.
   */
  $: needConfirmation =
    $userQuery &&
    $userQuery.data &&
    $userQuery.data.object &&
    $userQuery.data.object.ccEnabled === null &&
    !$userQuery.data.object.pretendEnabled &&
    !$userQuery.data.object.realCreatorId;
</script>

{#if needConfirmation && !$createProfileModalOpen}
  <form on:submit={submitForm}>
    <Modal
      open={true}
      title={$_('components.updateCountryProfileModal.title', {
        default: 'Please select your country from the drop-down menu below.',
      })}
      dismissable={false}
    >
      <div class="text-gray-500">
        {$_('components.updateCountryProfileModal.body', {
          default:
            'You can change this at any time by going to the ‘Profile’ section of the web dashboard.',
        })}
      </div>
      <Select
        required
        items={COUNTRY_CODE_DATA.map((c) => ({
          name: c.name,
          value: c.code,
        }))}
        bind:value={country}
      />
      <svelte:fragment slot="footer">
        <div class="flex w-full justify-end">
          <LoadingButton type="submit" bind:loading>
            {$_('components.updateCountryProfileModal.save', {
              default: 'Save',
            })}
          </LoadingButton>
        </div>
      </svelte:fragment>
    </Modal>
  </form>
{/if}
